import React, { useState } from 'react'
import type { DialogProps } from '@paintscout/ui'
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Alert,
  makeStyles
} from '@paintscout/ui'

export interface ConfirmationDialogProps extends DialogProps {
  title?: React.ReactNode
  message?: React.ReactNode
  yesLabel?: React.ReactNode
  noLabel?: React.ReactNode
  onConfirm?: (event: React.MouseEvent<HTMLElement>) => void
  onCancel?: (event: React.MouseEvent<HTMLElement>) => void
  scary?: boolean
}

const useStyles = makeStyles((theme) => ({
  content: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start'
  },
  scaryButton: {
    background: theme.palette.error.main
  }
}))

function ConfirmationDialog({
  onCancel,
  onConfirm,
  title = 'Are you sure?',
  message,
  yesLabel = 'OK',
  noLabel,
  scary,
  ...otherProps
}: ConfirmationDialogProps) {
  const [loading, setLoading] = useState(false)
  const classes = useStyles(otherProps)
  async function handleConfirm(ev: any) {
    const loadingTimeout = setTimeout(() => setLoading(true), 1)
    await onConfirm(ev)
    setLoading(false)
    clearTimeout(loadingTimeout)
  }

  return (
    <Dialog onClose={onCancel} {...otherProps}>
      <DialogTitle loading={loading}>{title}</DialogTitle>
      <DialogContent className={classes.content}>
        {scary ? (
          <Alert content={message} severity={'error'} variant="default" />
        ) : (
          <Typography variant="body1" component="div" align="left">
            {message}
          </Typography>
        )}
      </DialogContent>
      <DialogActions
        leftButton={
          <Button variant="text" disabled={loading} onClick={onCancel}>
            {noLabel ? noLabel : `Cancel`}
          </Button>
        }
      >
        <Button
          variant="contained"
          disabled={loading}
          onClick={handleConfirm}
          className={scary ? classes.scaryButton : null}
        >
          {yesLabel}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
